import { DEFAULT_AMPLIFY_ROUTES } from '@localstack/constants';
import { ReactElement, useState } from 'react';
import { useAwsEffect, useAwsGetter, useRoutes } from '@localstack/services';
import { Button, Card } from '@mui/material';
import { AmplifyAppsTable, ButtonWithDialog, PageTitle, Dropdown } from '@localstack/ui';

import { AmplifyProps } from './types';

export const AmplifyApps = ({
  Layout,
  clientOverrides,
  routes = DEFAULT_AMPLIFY_ROUTES,
}: AmplifyProps): ReactElement => {
  const { goto } = useRoutes();
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const { data: apps, isLoading, mutate } = useAwsGetter('Amplify', 'listApps', [], { clientOverrides });
  const { deleteApp } = useAwsEffect('Amplify', ['deleteApp'], {
    revalidate: ['listApps'],
    clientOverrides,
  });
  const handleRemove = async () => {
    await Promise.all(selectedIds.map(async (id) => deleteApp({ appId: id })));
  };
  return (
    <Layout
      title={<PageTitle title="Amplify Apps" onMutate={mutate} />}
      actions={
        <>
          <Button variant="outlined" onClick={() => goto(routes.RESOURCES_AMPLIFY_APP_CREATE)}>
            Create App
          </Button>
          <Dropdown label="Actions">
            <ButtonWithDialog
              componentType="MenuItem"
              disabled={selectedIds.length === 0 || isLoading}
              dialogTitle={`Delete ${selectedIds.length} App(s)?`}
              onClick={handleRemove}
              dialogContent="Selected Apps will be permanently deleted"
            >
              Remove Selected
            </ButtonWithDialog>
          </Dropdown>
        </>
      }
    >
      <Card>
        <AmplifyAppsTable
          apps={apps?.apps ?? []}
          onViewApp={(id: string) => goto(routes.RESOURCES_AMPLIFY_APP, { appId: id })}
          loading={isLoading}
          onSelect={setSelectedIds}
        />
      </Card>
    </Layout>
  );
};
